// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stepper_stepperContainer__foxvH {
  width: 100%;
  height: 30px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.Stepper_dot__ZWIb2 {
  height: 16px;
  width: 16px;
  padding: 6px;
  line-height: 16px;
  background-color: #e8e8e8;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  font-size: 16px;
  margin-right: 5px;
}

.Stepper_dotSelected__la9Zb {
  height: 16px;
  width: 16px;

  padding: 6px;
  line-height: 16px;
  background-color: var(--color-theme-lightblue);
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  font-size: 16px;
  color: var(--color-font-blue);
  font-weight: bold;
  margin-right: 5px;
}

.Stepper_stepContainer__qMXEL {
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.Stepper_stepContainerSelected__urmei {
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid var(--color-theme-blue);
}

.Stepper_fontSelected__RINBX {
  font-size: 16px;
  font-weight: bold;
  color: var(--color-theme-blue);
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/AccountCreation/components/Stepper/Stepper.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;;EAEX,YAAY;EACZ,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC","sourcesContent":[".stepperContainer {\n  width: 100%;\n  height: 30px;\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dot {\n  height: 16px;\n  width: 16px;\n  padding: 6px;\n  line-height: 16px;\n  background-color: #e8e8e8;\n  border-radius: 50%;\n  display: inline-block;\n  text-align: center;\n  font-size: 16px;\n  margin-right: 5px;\n}\n\n.dotSelected {\n  height: 16px;\n  width: 16px;\n\n  padding: 6px;\n  line-height: 16px;\n  background-color: var(--color-theme-lightblue);\n  border-radius: 50%;\n  display: inline-block;\n  text-align: center;\n  font-size: 16px;\n  color: var(--color-font-blue);\n  font-weight: bold;\n  margin-right: 5px;\n}\n\n.stepContainer {\n  padding: 5px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.stepContainerSelected {\n  padding: 5px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-bottom: 1px solid var(--color-theme-blue);\n}\n\n.fontSelected {\n  font-size: 16px;\n  font-weight: bold;\n  color: var(--color-theme-blue);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepperContainer": `Stepper_stepperContainer__foxvH`,
	"dot": `Stepper_dot__ZWIb2`,
	"dotSelected": `Stepper_dotSelected__la9Zb`,
	"stepContainer": `Stepper_stepContainer__qMXEL`,
	"stepContainerSelected": `Stepper_stepContainerSelected__urmei`,
	"fontSelected": `Stepper_fontSelected__RINBX`
};
export default ___CSS_LOADER_EXPORT___;
